export default "__VITE_ASSET__DP6d2zBN__"